import React, { useRef } from "react";
import styled from "styled-components";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import logo from "../assets/logo.png";
import ASLogo from "../assets/asitesLogoL.png";
import { Link } from "react-router-dom";

gsap.registerPlugin(ScrollTrigger);

const Footer = () => {
  const container = useRef();
  const bigTextRef = useRef();

  useGSAP(
    () => {
      // The "Magnification" effect on the background text as you scroll into the footer
      gsap.fromTo(
        bigTextRef.current,
        { y: 100, opacity: 0, scale: 0.8 },
        {
          y: 0,
          opacity: 0.05,
          scale: 1,
          scrollTrigger: {
            trigger: container.current,
            start: "top bottom",
            end: "bottom bottom",
            scrub: 1,
          },
        },
      );
    },
    { scope: container },
  );

  const scrollToTop = () => {
    gsap.to(window, { duration: 1.5, scrollTo: 0, ease: "power4.inOut" });
  };

  return (
    <FooterWrapper ref={container}>
      {/* MASSIVE BACKGROUND TEXT */}
      <BigBackgroundText ref={bigTextRef}>ERA</BigBackgroundText>

      <FooterContent>
        <TopRow>
          <BrandColumn>
            <img src={logo} alt="" />
            {/* <Tagline>Redefining the art of facial balance.</Tagline> */}
          </BrandColumn>

          <NavColumn>
            <NavLink href="#">Booking</NavLink>
            <NavLink href="#">Academy</NavLink>
            <NavLink href="#">About Us</NavLink>
            <NavLink href="#">Contact Us</NavLink>
          </NavColumn>

          <ActionColumn>
            <ScrollTopBtn onClick={scrollToTop}>
              <ArrowIcon>↑</ArrowIcon>
              Back to Top
            </ScrollTopBtn>
          </ActionColumn>
        </TopRow>

        <BottomRow>
          <Copyright>© 2026 ERA Aesthetics — All rights reserved.</Copyright>
          <SocialLinks>
            <Link to={"/terms-and-conditions"}>
              <small>TERMS AND CONDITIONS</small>
            </Link>
            {/* <small>WHATSAPP</small>
            <small>FACEBOOK</small> */}
          </SocialLinks>
        </BottomRow>
        <Agency>
          <p>Developed and Designed by:</p>
          <Link to={"https://www.instagram.com/asitesagency/"} target="_blank">
            <img src={ASLogo} alt="" />
          </Link>
        </Agency>
      </FooterContent>
    </FooterWrapper>
  );
};

export default Footer;

// --- Styled Components ---

const MAIN_COLOR = "#5a5248";

const FooterWrapper = styled.footer`
  width: 100%;
  background-color: #daccbd;
  color: ${MAIN_COLOR};
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 4em 10% 4rem 10%;
`;
const Copyright = styled.div`
  opacity: 0.6;
  font-size: 0.7rem;
  letter-spacing: 0.1rem;
`;

const Agency = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* gap: 1em; */
  margin-top: 2em;
  p {
    text-align: center;
    color: #8b7f7f;
  }
  img {
    width: 120px;
  }
`;

const BigBackgroundText = styled.h2`
  position: absolute;
  top: -70%;
  left: 50%;
  transform: translateX(-50%);
  font-size: 25vw;
  font-family: "Playfair Display", serif;
  color: ${MAIN_COLOR};
  white-space: nowrap;
  pointer-events: none;
  z-index: 0;
  letter-spacing: -0.05em;
  display: none;
`;

const FooterContent = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  z-index: 1;
`;

const TopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding-bottom: 4rem;
  border-bottom: 1px solid rgba(90, 82, 72, 0.1);

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 3rem;
  }
`;

const BrandColumn = styled.div`
  max-width: 300px;
  img {
    width: 180px;
  }
`;

const LogoText = styled.h3`
  font-family: "Playfair Display", serif;
  font-size: 2rem;
  /* margin-bottom: 1rem; */
`;

const Tagline = styled.p`
  font-size: 0.9rem;
  opacity: 0.7;
  line-height: 1.5;
`;

const NavColumn = styled.nav`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem 3rem;
`;

const NavLink = styled.a`
  color: ${MAIN_COLOR};
  text-decoration: none;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.1rem;
  transition: opacity 0.3s;
  &:hover {
    opacity: 0.5;
  }
`;

const ActionColumn = styled.div`
  text-align: right;
`;

const ScrollTopBtn = styled.button`
  background: none;
  border: none;
  color: ${MAIN_COLOR};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.2rem;
  gap: 10px;
  transition: transform 0.3s;

  &:hover {
    transform: translateY(-5px);
  }
`;

const ArrowIcon = styled.span`
  font-size: 1.5rem;
  border: 1px solid rgba(90, 82, 72, 0.3);
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
`;

const BottomRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 2rem;
  font-size: 0.7rem;
  letter-spacing: 0.1rem;
  opacity: 0.6;
  color: #000000;
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 2rem;
  small {
    cursor: pointer;
    &:hover {
      opacity: 0.5;
    }
  }
`;
